import { Slider } from "@mui/material";
import { useState } from "react";

interface PercentSliderSubInputProps {
  defaultValue: number | null;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

function PercentSliderSubInput({
  defaultValue,
  onInputChange,
  disabled,
}: PercentSliderSubInputProps){
  const [inputValue, setInputValue] = useState(defaultValue ?? 0);
  const onChange = (
    _: Event,
    newValue: number | number[],
    __: number
  ): void => {
    setInputValue(Array.isArray(newValue) ? newValue[0] : newValue);
    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  return (
    <div className="flex w-full flex-col items-center">
      <Slider
        className="w-full"
        classes={{
          track: "bg-rmh-deepblue-500",
          rail: "bg-rmh-deepblue-25",
        }}
        disabled={disabled}
        marks
        max={100}
        min={0}
        onChange={onChange}
        step={25}
        value={typeof inputValue === "number" ? inputValue : 0}
      />
      <div className="mt-1 flex w-3/4 items-center justify-center rounded-lg border border-black bg-white py-1">
        {inputValue}
      </div>
    </div>
  );
}

export default PercentSliderSubInput;
